module.exports = __webpack_public_path__ + "static/media/elektroniikka-min.6c4015b5.jpg";